"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M13.32 5.25a1.341 1.341 0 0 0-.334-.441c-.195-.165-.495-.309-.986-.309-.49 0-.791.144-.986.309-.142.12-.253.272-.335.441h2.642Zm-2.821 0h.001-.001Zm-1.345-.213a1.324 1.324 0 0 0-.049.213H6.75A2.25 2.25 0 0 0 6 9.622v8.733C6 19.843 7.245 21 8.719 21h6.562C16.755 21 18 19.843 18 18.355V9.622a2.25 2.25 0 0 0-.75-4.372h-2.355a1.32 1.32 0 0 0-.05-.213 2.95 2.95 0 0 0-.89-1.374C13.468 3.252 12.817 3 12 3c-.817 0-1.468.252-1.955.663a2.949 2.949 0 0 0-.89 1.374ZM6.75 6.75h10.5a.75.75 0 0 1 0 1.5H6.75a.75.75 0 0 1 0-1.5Zm9.75 3V18a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 18V9.75h9Zm-8.25 7.5a.75.75 0 0 0 1.5 0V12a.75.75 0 0 0-1.5 0v5.25Zm6 0a.75.75 0 0 0 1.5 0V12a.75.75 0 0 0-1.5 0v5.25ZM12 18a.75.75 0 0 1-.75-.75V12a.75.75 0 0 1 1.5 0v5.25A.75.75 0 0 1 12 18Z",
    clipRule: "evenodd"
  })]
});